import Grid from '@mui/material/Grid'
import { ChangeEvent } from 'react'

import Typography from '@/components/common/Typography'
import RadioGroup from '@/components/common/Inputs/RadioGroup'
import WeeklySchedule from '@/components/generics/WeeklySchedule'
import { DELIVERY_RADIUS } from '@/constants'
import { DELIVERY_RADIO_BOX } from '@/constants/testIds'
import { stringToBoolean } from '@/utils'

import { CourierSchedule } from '@/common/types'
import { DayEnum } from '@/common/enums'
import { FormikErrors } from 'formik'
import { useStyles } from '../styles'

type ScheduleValues = {
    workingHours: CourierSchedule[]
    availableWeekdays?: boolean | null
    availableSaturday?: boolean | null
    deliveryRadius?: string
    enabledDays?: Record<DayEnum, boolean>
}

interface Props {
    values: ScheduleValues
    errors: FormikErrors<ScheduleValues>
    setFieldValue: (_field: string, _value: any, _shouldValidate?: boolean | undefined) => Promise<void> | Promise<FormikErrors<ScheduleValues>>
    enabledDays?: Record<DayEnum, boolean>
    onEnabledDaysChange?: (_nextValue: Record<DayEnum, boolean>) => void
}

const Schedule = ({ values, errors, setFieldValue, enabledDays, onEnabledDaysChange }: Props) => {
    const { classes } = useStyles()

    return (
        <div className={classes.scheduleWrapper}>
            <div className={classes.scheduleHeader}>
                {/*<Typography variant='h5' weight='500' color='textPrimary' className={classes.scheduleTitle}>*/}
                {/*    Work schedule*/}
                {/*</Typography>*/}
                <Typography variant='body2' color='textSecondary'>
                    Select the days and time ranges you are available to deliver.
                </Typography>
            </div>
            <Grid container direction='column' rowSpacing={4} className={classes.scheduleGrid}>
                <Grid item>
                    <div className={classes.hoursBlock}>
                        <WeeklySchedule
                            value={values.workingHours}
                            onChange={(value) => setFieldValue('workingHours', value)}
                            enabledDays={enabledDays}
                            onEnabledDaysChange={onEnabledDaysChange}
                        />
                        {typeof errors?.workingHours === 'string' && (
                            <Typography variant='caption' color='error'>
                                {errors.workingHours}
                            </Typography>
                        )}
                    </div>
                </Grid>
                {/*<Grid item>*/}
                {/*    <div className={classes.hoursBlock}>*/}
                {/*        <Typography variant='body1' weight='500' color='textPrimary' className={classes.scheduleSectionTitle}>*/}
                {/*            Are you available on weekdays? **/}
                {/*        </Typography>*/}
                {/*        <RadioGroup*/}
                {/*            items={[]}*/}
                {/*            value={values.availableWeekdays}*/}
                {/*            error={errors?.availableWeekdays || null}*/}
                {/*            onChange={(e) => {*/}
                {/*                const val = stringToBoolean(e.target.value)*/}
                {/*                setFieldValue('availableWeekdays', val)*/}
                {/*            }}*/}
                {/*        />*/}
                {/*    </div>*/}
                {/*</Grid>*/}
                {/*/!*<Grid item>*!/*/}
                {/*/!*    <div className={classes.hoursBlock}>*!/*/}
                {/*/!*        <Typography variant='body1' weight='500' color='textPrimary' className={classes.scheduleSectionTitle}>*!/*/}
                {/*/!*            Are you available on Saturdays? **!/*/}
                {/*/!*        </Typography>*!/*/}
                {/*/!*        <RadioGroup*!/*/}
                {/*/!*            items={[]}*!/*/}
                {/*/!*            value={values.availableSaturday}*!/*/}
                {/*/!*            error={errors?.availableSaturday || null}*!/*/}
                {/*/!*            onChange={(e) => {*!/*/}
                {/*/!*                const val = stringToBoolean(e.target.value)*!/*/}
                {/*/!*                setFieldValue('availableSaturday', val)*!/*/}
                {/*/!*            }}*!/*/}
                {/*/!*        />*!/*/}
                {/*/!*    </div>*!/*/}
                {/*/!*</Grid>*!/*/}
                {/*<Grid item>*/}
                {/*    <div className={classes.hoursBlock}>*/}
                {/*        <Typography variant='body1' weight='500' color='textPrimary' className={classes.scheduleSectionTitle}>*/}
                {/*            Delivery distance you are going to work*/}
                {/*        </Typography>*/}
                {/*        <RadioGroup*/}
                {/*            id={DELIVERY_RADIO_BOX}*/}
                {/*            items={DELIVERY_RADIUS}*/}
                {/*            value={values.deliveryRadius}*/}
                {/*            error={errors?.deliveryRadius || null}*/}
                {/*            onChange={(e: ChangeEvent<{ value: string }>) => {*/}
                {/*                const val = e.target.value*/}
                {/*                setFieldValue('deliveryRadius', val)*/}
                {/*            }}*/}
                {/*        />*/}
                {/*    </div>*/}
                {/*</Grid>*/}
            </Grid>
        </div>
    )
}

export default Schedule
